export const SET_PAYMENT_DETAILS = 'cart/payment/SET_PAYMENT_DETAILS'



// WEBPACK FOOTER //
// ./src/containers/Cart/Payment/constants.js